import * as fs from "node:fs";
import * as path from "node:path";
import { LocalCliError } from "./errors.js";
import { resolveRepoRoot } from "./brain-paths.js";

/**
 * THE seed-source seam. Resolves a seed NAME to a directory of overlay content.
 *
 *   v1 (in-repo):  brain-seeds/<name>/ under the repo root.
 *   Graduation:    swap THIS body to clone/cache a remote seed/template repo and
 *                  return its local path. Callers stay agnostic to the source —
 *                  this is the single line that changes.
 *
 * Throws LocalCliError(SEED_NOT_FOUND) when the named seed dir is absent.
 */
export function resolveSeed(name: string): string {
  const dir = path.join(resolveRepoRoot(), "brain-seeds", name);
  if (!fs.existsSync(dir)) {
    throw new LocalCliError({
      code: "SEED_NOT_FOUND",
      message: `--seed "${name}": no brain-seeds/${name}/ directory found.`,
      hint: "Seeds live under brain-seeds/. Check the name, or omit --seed for an unseeded brain.",
    });
  }
  return dir;
}

/**
 * Materialize a brain repo tree into destDir: copy the structural template,
 * then (if a seed is given) overlay the seed's content on top — seed wins on
 * every collision (fs.cpSync force:true; no merge). With no seedDir, the body
 * is exactly today's single cpSync → byte-identical no-seed guarantee.
 */
export function materializeBrainTree(opts: {
  templateSrc: string;
  destDir: string;
  seedDir?: string;
}): void {
  fs.cpSync(opts.templateSrc, opts.destDir, { recursive: true });
  if (opts.seedDir) {
    fs.cpSync(opts.seedDir, opts.destDir, { recursive: true });
  }
}
